'use strict';
require('copy!./img/favicons/apple-touch-icon-57x57.png');
require('copy!./img/favicons/apple-touch-icon-60x60.png');
require('copy!./img/favicons/apple-touch-icon-72x72.png');
require('copy!./img/favicons/apple-touch-icon-76x76.png');
require('copy!./img/favicons/apple-touch-icon-114x114.png');
require('copy!./img/favicons/apple-touch-icon-120x120.png');
require('copy!./img/favicons/apple-touch-icon-144x144.png');
require('copy!./img/favicons/apple-touch-icon-152x152.png');
require('copy!./img/favicons/apple-touch-icon-180x180.png');
require('copy!./img/favicons/favicon-32x32.png');
require('copy!./img/favicons/favicon-194x194.png');
require('copy!./img/favicons/favicon-96x96.png');
require('copy!./img/favicons/android-chrome-192x192.png');
require('copy!./img/favicons/favicon-16x16.png');
require('copy!./img/favicons/favicon.ico');
// Let webpack 5 asset modules emit the manifest once:
require('./img/favicons/manifest.json');
require('copy!./img/favicons/browserconfig.xml');
